// CIcon compat: supports v3 usage `<CIcon name="cil-list" />` on top of
// @coreui/icons-react v2, which requires `icon={cilList}` objects.
import React from 'react';
import CIconBase from '@coreui/icons-react';
import * as allIcons from '@coreui/icons';

const nameToIcon = (name) => {
  if (!name) return null;
  const camel = name.replace(/-([a-z0-9])/g, (_, c) => c.toUpperCase());
  return allIcons[camel] || null;
};

const CIcon = ({ name, icon, content, customClasses, customClassName, className, ...rest }) => {
  const resolved = icon || content || nameToIcon(name);
  if (!resolved) return null;
  return (
    <CIconBase
      icon={resolved}
      customClassName={customClassName || customClasses}
      className={className}
      {...rest}
    />
  );
};

export default CIcon;
